// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"6f52298b","508":"201e5158","787":"42bce9e7"}[chunkId] + ".chunk.js";
};